import { Button, Flex, Form } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarSelector } from "../../../../components";
import { PanelDateType } from "../../../../components/CalendarSelector/data";
import { useLoading } from "../../../../context/LoadingContext";
import { useGetCoachSchedule } from "../../../../hooks/Coach/coach.hooks";
import { pushGtag } from "../../../../plugins/utils";
import { InputRequired } from "../../../../validations/validations";
import { step } from "../../enumerations/step";
import "./styles.scss";

const CoachCalendar = ({
  open,
  params,
  form,
  setSteps,
}: {
  open: boolean;
  params: any;
  form: any;
  setSteps: (val: string) => void;
}) => {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();
  const pathname = window.location.pathname.split("/");
  const coachId = [...pathname].pop();
  const [panelDate, setPanelDate] = useState<PanelDateType>();

  const { data: coachSchedule, isPending } = useGetCoachSchedule(
    { coach_id: coachId, ...panelDate, ...params },
    { enabled: open && !!coachId && !!panelDate }
  );

  const handlePrevStep = () => {
    pushGtag({
      event: "book_coach_prev_step",
    });

    setSteps(step.OTHER);
  };

  useEffect(() => {
    if (!open) {
      setPanelDate(undefined);
    }
  }, [open]);

  useEffect(() => {
    if (!params) return;
    // console.debug("params", params);
  }, [params]);

  return (
    <>
      <Form.Item
        name={"date"}
        label={t("home.searchbar.date.title")}
        rules={[InputRequired(t, "home.searchbar.date.title")]}
      >
        <CalendarSelector
          setPanelDate={setPanelDate}
          schedule={coachSchedule}
          form={form}
          isLoading={isPending}
        />
      </Form.Item>
      <Form.Item name={"start_date"} hidden />
      <Form.Item name={"end_date"} hidden />
      <Flex gap={8}>
        <Button onClick={handlePrevStep}>{t("normal.prestep")}</Button>
        <Button type="primary" htmlType="submit" style={{ flex: 1 }}>
          {t("coachInfo.bookModal.okText")}
        </Button>
      </Flex>
    </>
  );
};

export default CoachCalendar;
